// extracted by mini-css-extract-plugin
export default {"question":"Toggle-module__question-ceedli"};